export var selectIsShowNotification = function selectIsShowNotification(state) {
  return state.favoritesAssignWidget.showNotification;
};